import { AssetTypeEnum, AssetTypeLabels } from '@api/enum';
import { Button, Card, HelpText, Label } from '@hyperflake/react-ui-library';
import { ErrorMessage, Form, Formik } from 'formik';
// import { FormikSelect, FormikTextarea } from 'modules/shared/features/formik';
// import { useAssetPurchaseOrderAddForm } from 'modules/asset/hooks/useAssetPurchaseOrderAddForm';
import { FormHelperText } from '@library/forms';
import { useMemo } from 'react';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useAssetPurchaseOrderAddForm } from 'modules/asset-purchase-order/hooks/useAssetPurchaseOrderAddForm';
// import { FormikTextarea } from '@hyperflake/react-ui-library/formik/index.js';
import { FormikInput, FormikSelect } from 'modules/shared/features/formik';
import FormikTextarea from 'modules/shared/features/formik/components/FormikTextarea/FormikTextarea';
import DocFileIcon from '@components/DocFileIcon/DocFileIcon';
import { getFileExtension } from '@utils/file-utils';

const AddAssetPurchaseOrderForm = () => {
    const { clientInstallationId, projectInstallationId } = useParams();
    const formHook = useAssetPurchaseOrderAddForm(clientInstallationId, projectInstallationId);
    const navigate = useNavigate();

    const assetTypeOptions = useMemo(() => {
        return [
            { label: 'Select Asset', value: '' },
            ...Object.values(AssetTypeEnum).map((val) => ({
                label: AssetTypeLabels[val], // Display human-readable label
                value: val,
            })),
        ];
    }, []);

    const handleSubmit = async (values: any) => {
        try {
            await formHook.submit(values);
            toast.success('Asset Purchase Order Added Successfully');
            navigate(
                `/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/purchase-order`
            );
        } catch (err: any) {
            toast.error(err?.data?.message || 'Something went wrong.');
        }
    };

    return (
        <Formik initialValues={formHook.initialValues} validationSchema={formHook.schema} onSubmit={handleSubmit}>
            {({ values, setFieldValue, isSubmitting }) => (
                <Form>
                    <Card className="mt-4">
                        <Card.Header>Asset Purchase Order</Card.Header>
                        <Card.Body>
                            {/* Remarks */}
                            <div>
                                <Label>Remarks</Label>
                                <FormikTextarea name="remarks" rows={4} />
                                <HelpText variant="error">
                                    <ErrorMessage name="remarks" />
                                </HelpText>
                            </div>

                            {/* Type of Asset */}
                            <div className="mt-4">
                                <Label>Type of Asset</Label>
                                <FormikSelect name="typeOfAssets" options={assetTypeOptions} />
                                <HelpText variant="error">
                                    <ErrorMessage name="typeOfAssets" />
                                </HelpText>
                            </div>

                            {/*Quantity */}
                            <div className="mt-4">
                                <Label>Quantity</Label>
                                <FormikInput name="quantity" type="number" />
                                <HelpText variant="error">
                                    <ErrorMessage name="quantity" />
                                </HelpText>
                            </div>
                        </Card.Body>
                    </Card>

                    <Card className="mt-4">
                        <Card.Header>Documents</Card.Header>
                        <Card.Body>
                            {/* File Upload */}
                            <div className="mt-4">
                                <Label>Upload Files</Label>
                                <input
                                    type="file"
                                    multiple
                                    className="ml-4"
                                    onChange={(event) => {
                                        const selectedFiles = event.currentTarget.files;
                                        if (selectedFiles) {
                                            setFieldValue('files', Array.from(selectedFiles));
                                        }
                                    }}
                                />
                                <ul className="mt-2 list-disc pl-5">
                                    {values.files.map((file: File, idx: number) => (
                                        <li key={idx} className="flex  items-center gap-2">
                                            <DocFileIcon className="w-7" extension={getFileExtension(file.name)} />
                                            {file.name}
                                            <Button
                                                size="xs"
                                                type="button"
                                                className="ml-2"
                                                onClick={() => {
                                                    const updated = [...values.files];
                                                    updated.splice(idx, 1);
                                                    setFieldValue('files', updated);
                                                }}
                                            >
                                                Remove
                                            </Button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Card.Body>
                    </Card>

                    <Button type="submit" className="mt-6 w-full sm:w-auto" disabled={isSubmitting}>
                        {isSubmitting ? 'Submitting...' : 'Add Order'}
                    </Button>
                </Form>
            )}
        </Formik>
    );
};

export default AddAssetPurchaseOrderForm;
